import {AppDataTable, AppTableSkeleton} from "@components"
import {exportUrlColumn, officeDataColumn, reportNameColumn} from "Pages/Admin/GroupedExports/Modal/Table/@columns"
import React from "react"


export default function GroupedExportsModalTable({ data, isLoading }) {

	if (isLoading) return <AppTableSkeleton rows={9} columns={3}/>

	return <AppDataTable
		title=""
		data={data}
		columns={[ reportNameColumn(), ...officeDataColumn(), exportUrlColumn() ]}
	/>
}